import React, { useContext, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { PageContext } from "~/App";

export function HRRoot() {
  const { pages } = useContext(PageContext);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const paths = pathname.split("/");

  useEffect(() => {
    const module = pages?.find((page) => page.name === paths[1]);
    const hrPage = module?.children.find(
      (page) => page.path === `/${paths[1]}/${paths[2]}`
    );
    const defaultChild = hrPage?.children?.[0]?.path;

    if (
      defaultChild &&
      pathname.toUpperCase() === `/${paths[1]}/${paths[2]}`.toUpperCase()
    ) {
      navigate(defaultChild);
    }
  }, [navigate, pages, pathname, paths]);

  return <Outlet />;
}

export default HRRoot;
